// Single source of truth for the board Locate-cell label + color, so the Master
// Board, Manager Board, Mobile cards, and Quick Editor cannot drift.
//
// Backend provides SEMANTIC fields only (no colors): locate_status
// (valid | expiring | invalid), locate_status_reason, locate_status_detail,
// current_trouble_count. The Trouble tag is a VISUAL warning only and never
// changes backend readiness / field_start_ready.

const VARIANTS = {
  green: { color: "#166534", background: "transparent" },
  amber: { color: "#92400e", background: "#fef3c7" },
  red: { color: "#b91c1c", background: "transparent" },
  lightRed: { color: "#b91c1c", background: "#fee2e2" },
  darkRed: { color: "#7f1d1d", background: "#fca5a5" },
};

function reasonLabel(row) {
  const reason = row.locate_status_reason || "";
  if (
    row.locate_required &&
    row.locate_status === "invalid" &&
    row.locate_status_detail === "requires_locates"
  ) {
    return "PENDING";
  }
  if (reason === "Expiration date required") return "EXPIRATION DATE REQUIRED";
  if (reason === "Locate in Trouble") return "NOT READY";
  if (reason === "Locate expiration date must be refreshed") return "RENEWAL REQUIRED";
  if (reason === "Missing required record") return "NOT READY";
  return "NOT READY";
}

// Returns { label, variant: {color, background} } for the Locate cell.
export function locateCellView(row) {
  const state = row.locate_status;
  const trouble = Number(row.current_trouble_count || 0);
  const troubleTag = trouble > 0 ? ` • TROUBLE (${trouble})` : "";

  if (state === "valid") {
    return {
      label: `READY${troubleTag}`,
      variant: trouble > 0 ? VARIANTS.lightRed : VARIANTS.green,
    };
  }
  if (state === "expiring") {
    return {
      label: `EXPIRING${troubleTag}`,
      variant: trouble > 0 ? VARIANTS.lightRed : VARIANTS.amber,
    };
  }
  // invalid — show the actionable reason; append the Trouble tag separately so it
  // never replaces the reason.
  const base = reasonLabel(row);
  if (trouble > 0) {
    // "NOT READY" already implies the trouble reason; avoid "NOT READY • TROUBLE (n)"
    // redundancy by using the compact form the spec asked for.
    const label =
      base === "NOT READY" ? "NOT READY • TROUBLE" : `${base} • TROUBLE (${trouble})`;
    return { label, variant: VARIANTS.darkRed };
  }
  return { label: base, variant: VARIANTS.red };
}
